"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.filter.dateFrom': 'Fecha desde',
    'dblogs.filter.dateTo': 'Fecha hasta',
    'dblogs.filter.models': 'Modelos',
    'dblogs.filter.models.placeholder': 'Todos los modelos',
    'dblogs.filter.operations': 'Operaciones',
    'dblogs.filter.operations.placeholder': 'Todas las operaciones',
    'dblogs.filter.recordIds': 'IDs de registro',
    'dblogs.filter.recordIds.placeholder': 'Añadir valor con Enter',
    'dblogs.filter.search': 'Buscar',
};
